import { render, staticRenderFns } from "./AcquiringDocuments.vue?vue&type=template&id=675f0364&scoped=true&"
import script from "./AcquiringDocuments.vue?vue&type=script&lang=js&"
export * from "./AcquiringDocuments.vue?vue&type=script&lang=js&"
import style0 from "./AcquiringDocuments.vue?vue&type=style&index=0&id=675f0364&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675f0364",
  null
  
)

export default component.exports